/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ParticipantConsentOut } from './participantConsentOut';
import type { ReplyOut } from './replyOut';

export interface ConsentOut {
  mode_code: string;
  policy_source_code: string;
  participants: ParticipantConsentOut[];
  replies: ReplyOut[];
  legal_hold_until: string | null;
  revoked_at: string | null;
  cut_media_lost: boolean;
  cut_queued: boolean;
}
